/* eslint-disable no-unused-vars */
// TODO - temporarily removing the POST dependency until component is updated
import React from 'react';
// import React, { useContext, useEffect, useMemo, useState } from 'react';
// import { Button, VisuallyHidden } from '@vp/swan';
// import { isDocumentSupportedByPOST, POSTModal } from '@vp/post-order-studio';
// import { useTranslations } from '@vp/om-translations';
// import useSiteData from '../../../hooks/useSiteData';
// import { SelfEditPreRequestModal } from '../selfUpdate/SelfEditPreRequestModal';
// import { SelfEditPostRequestModal } from '../selfUpdate/SelfEditPostRequestModal';
// import { requestDesignUpdate } from '../../../apis/orderUpdateRequestsApi';
// import { trackPostOrderDesignEditAvailability } from '../../../apis/newRelicTrackingApi';
// import { getAuthHeaderAndShoppgetShopperIderId } from '../../../util/auth';
// import { useLineItemData } from '../LineItemDataProvider';
// import { ORDER_DETAILS_SOURCE_PAGE } from '../../../constants/orderdetailsui';
// import { LineItemActionsContext } from '../../contexts/LineItemActionsContext';

/**
 *
 * Expected that this is rendered within an LineItemDataProvider to access item properties
 *
 * The entry point to the Edit Design Pre Fulfillment feature (aka POST Studio)
 *
 * When rendered, will immediately check to see if the order item document is valid for POST.
 * If so, it will render the "Edit Design" text link which will open the POST flow.
 */
export const ItemEditDesignButton = ({ ...buttonProps }) => {};
//   const [isPreRequestModalOpen, setIsPreRequestModalOpen] = useState(false);
//   const [isPOSTModalOpen, setIsPOSTModalOpen] = useState(false);
//   const [isPostRequestModalOpen, setIsPostRequestModalOpen] = useState(false);
//   const [isPOSTSupported, setIsPOSTSupported] = useState(false);
//   const [updateRequestSuccess, setUpdateRequestSuccess] = useState(false);
//   const [updateRequestFailure, setUpdateRequestFailure] = useState(false);
//   const [postOrderDesignUpdate] = useTranslations(['postOrderDesignUpdate']);
//   const {
//     id,
//     attributes: displayProductAttributes,
//     productName,
//     productKey,
//     productVersion,
//     documentUrl,
//     editDocumentUrl,
//     orderNumber,
//   } = useLineItemData();
//
//   const { locale, tenantEnvironment, vistacartTenant } = useSiteData();
//   const shopperId = getShopperId();
//
//   const { editAndReorderActionEnabled } = useContext(LineItemActionsContext);
//
//   const updateDesign = async modifiedDesignObject => {
//     try {
//       await requestDesignUpdate({
//         tenantEnvironment,
//         orderNumber,
//         modifiedDesignObject,
//         vistacartTenant,
//       });
//       // if it makes it here, thats a success! the success modal will be presented
//       setUpdateRequestSuccess(true);
//     } catch (err) {
//       setUpdateRequestFailure(true);
//     }
//   };
//
//   const onDocumentModifiedHandler = async (
//     promiseDocRefUrl,
//     promisePurcsData,
//     promiseLivePreviewUrl
//   ) => {
//     setIsPostRequestModalOpen(true);
//     Promise.all([
//       promiseDocRefUrl,
//       promisePurcsData,
//       promiseLivePreviewUrl,
//     ]).then(values => {
//       const [docRefUrl, purcsData, livePreviewUrl] = values;
//       const modifiedDesignObject = {
//         docRefUrl,
//         lineItemId: id,
//         livePreviewUrl,
//         purcsData,
//       };
//       updateDesign(modifiedDesignObject);
//     });
//   };
//
//   const productAttributesForPost = useMemo(() => {
//     const attributes = {};
//     if (displayProductAttributes) {
//       displayProductAttributes.forEach(attr => {
//         const { key, value } = attr;
//         attributes[key] = value;
//       });
//     }
//     return attributes;
//   }, [displayProductAttributes]);
//
//   useEffect(() => {
//     (async () => {
//       const propsForPOST = {
//         productId: productKey,
//         productName,
//         productVersion,
//         productOptions: productAttributesForPost,
//         docUri: documentUrl,
//         orderId: orderNumber,
//         editDocUri: editDocumentUrl,
//         locale,
//         sourcePage: ORDER_DETAILS_SOURCE_PAGE,
//         isEditAndReorderEnabled: editAndReorderActionEnabled,
//       };
//
//       const isSupported = await isDocumentSupportedByPOST(propsForPOST);
//       setIsPOSTSupported(isSupported);
//       propsForPOST.isPostSupported = isSupported;
//       trackPostOrderDesignEditAvailability(shopperId, propsForPOST);
//     })();
//   }, [
//     documentUrl,
//     editAndReorderActionEnabled,
//     editDocumentUrl,
//     locale,
//     orderNumber,
//     productAttributesForPost,
//     productKey,
//     productName,
//     productVersion,
//     shopperId,
//   ]);
//
//   return (
//     isPOSTSupported && (
//       <>
//         {/* eslint-disable-next-line react/jsx-props-no-spreading */}
//         <Button onClick={() => setIsPreRequestModalOpen(true)} {...buttonProps}>
//           {postOrderDesignUpdate.editDesign}
//           <VisuallyHidden>{`: ${productName}`}</VisuallyHidden>
//         </Button>
//
//         <SelfEditPreRequestModal
//           isOpen={isPreRequestModalOpen}
//           openNextStep={() => setIsPOSTModalOpen(true)}
//           onRequestDismiss={() => setIsPreRequestModalOpen(false)}
//           selfEditAction="post-order-design-edit"
//         />
//         <POSTModal
//           productId={productKey}
//           productName={productName}
//           productVersion={productVersion}
//           productOptions={productAttributesForPost}
//           docUri={documentUrl}
//           orderId={orderNumber}
//           editDocUri={editDocumentUrl}
//           locale={locale}
//           onDocumentModified={onDocumentModifiedHandler}
//           onRequestDismiss={() => setIsPOSTModalOpen(false)}
//           isOpen={isPOSTModalOpen}
//           tenant="Vistaprint"
//         />
//         <SelfEditPostRequestModal
//           isOpen={isPostRequestModalOpen}
//           updateRequestSuccess={updateRequestSuccess}
//           updateRequestFailure={updateRequestFailure}
//           onRequestDismiss={() => setIsPostRequestModalOpen(false)}
//           selfEditAction="post-order-design-edit"
//         />
//       </>
//     )
//   );
// };
